<template>
  <div class="h-dialogContainer">
    <form id="k8sEnvAddForm">
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('环境名称')}}</div>
              <input
                name="serviceName"
                class="e-input e-input-group"
                v-model="k8sEnvName"
                :placeholder="$t('请输入环境名称')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{this.$t('IP')}}</div>
              <input
                name="ipaddr"
                class="e-input e-input-group"
                v-model="k8sEnvIp"
                :placeholder="$t('请输入IP')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{this.$t('端口')}}</div>
              <input
                name="port"
                class="e-input e-input-group"
                v-model="k8sEnvPort"
                :placeholder="$t('请输入端口')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{this.$t('授权码')}}</div>
              <ejs-textbox
                name="authCode"
                multiline="true"
                class="e-input e-input-group"
                v-model="k8sAuthCode"
                :placeholder="$t('请输入授权码')"
              />
            </div>
          </div>
        </div>

        <!-- <div class='row h-row-insertBox'>
        <div class='col-sm-6 h-col-insertBox'>
          <ejs-button cssClass="e-small" :isPrimary="true" @click.native="checkAuthCode">{{$t('验证')}}</ejs-button>
                  
        </div>
        </div>-->
      </div>
    </form>
  </div>
</template>

<script>
import { EventBus } from "../../../plugins/eventBus";
import mixin from "../../../mixin/mixin";

export default {
  name: "addDialog",
  mixins: [mixin],
  data() {
    return {
      k8sEnvName: "",
      k8sEnvIp: "",
      k8sEnvPort: "",
      k8sAuthCode: "",
      formObj: "",
      inputNames: ["serviceName", "ipaddr", "port", "authCode"],
      flagCheckAuthCode: false,
      flagCheckIpRepeat: false,

      rules: {
        authCode: {
          required: true
        },
        serviceName: {
          required: true,
          maxLength: 30
        },
        ipaddr: {
          required: true,
          regex: "ipv4"
        },
        port: {
          required: true,
          regex: "integer",
          min: 1,
          max: 65535
        }
      }
    };
  },
  methods: {
    clear() {
      this.k8sEnvName = "";
      this.k8sEnvIp = "";
      this.k8sEnvPort = "";
      this.k8sAuthCode = "";
    },
    getData() {
      return {
        name: this.k8sEnvName,
        type: "5G",
        content: {
          k8sEnvIp: this.k8sEnvIp,
          k8sEnvPort: this.k8sEnvPort,
          k8sAuthCode: this.k8sAuthCode,
          k8sLabels: "",
          k8sTaints: ""
        }
      };
    },
    async checkAuthCode() {
      const params = this.getData();
      await this.$axios
        .post("/lte/ems/env/checkEnvironment.html", params)
        .then(response => {
          console.log(response);

          if (response && response.status === 200) {
            if (response.data.errorCode === "SUCCESS") {
              this.flagCheckAuthCode = true;
              return true;
            } else if(response.data.errorCode === "8609"){
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "warning",
                content: "集群名称与节点重复"
              });
              this.flagCheckAuthCode = false;
              return false;
            } else {
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "warning",
                content: "授权码验证失败"
              });
              this.flagCheckAuthCode = false;
              return false;
            }
          } else {
            this.$loading.hideLoadding();
            EventBus.$emit("toast", {
              type: "warning",
              content: "授权码验证失败"
            });
            this.flagCheckAuthCode = false;
            return false;
          }
        });
    },
    async checkIpRepeat() {
      this.flagCheckIpRepeat = false;
      if (!this.validate()) {
        return false;
      }
      this.$loading.showLoadding('环境添加中','请稍后');
      const params = {
        id: "",
        type: "5G",
        ip: this.k8sEnvIp
      };
      await this.$axios
        .post("/lte/ems/env/checkEnvIp.html", params)
        .then(response => {
          console.log(response);
          if (response && response.status === 200) {
            if (response.data.errorCode === "SUCCESS") {
              this.flagCheckIpRepeat = true;
              return true;
            } else {
              this.$loading.hideLoadding();
              EventBus.$emit("toast", {
                type: "warning",
                content: "IP重复"
              });
              this.flagCheckIpRepeat = false;
              return false;
            }
          } else {
            this.$loading.hideLoadding();
            EventBus.$emit("toast", {
              type: "warning",
              content: "IP验证失败"
            });
            this.flagCheckIpRepeat = false;

            return false;
          }
        });
    },

    bindValidate() {
      this.formObj = this.validateForm(
        "k8sEnvAddForm",
        this.inputNames,
        this.rules
      );
    },
    validate() {
      const formStatus = this.formObj.validate();
      return formStatus;
    }
  },
  eventEmit(type, content) {
    EventBus.$emit("toast", { type: type, content: content });
  },
  mounted() {
    this.bindValidate();
  }
};
</script>
